@use '@lib/assets/styles/main.scss' as *;
@use "@lib/components/Link/LinkExtends" as *;

$imageSize: 88px;

.root {
}

.images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.img {
  img, svg {
    display: block;
  }
}

.body {
  display: flex;
  gap: 16px;
}

.bodyWithFullWidthBtn {
  & > div {
    width: 100%;
  }
}

.documentationsPreview {
  & > * {
    margin-bottom: 8px;
  }
}
